import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'

const collection = 'tags'
const singleName = 'InputTag.vue'
const pluralName = 'tags'
const connection = 'config'

const model = {
  name: '',
  categorieId: '',
  color: ''
}

const validations = {
  name: {
    required: true,
    min: 1
  },
  categorieId: {
    required: true
  }
}

const getters = { ...mapGetters() }
getters[singleName] = state => state.one
getters[pluralName] = state => state.all

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    selecteds: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0,
    textTagsFilters: ''
  },
  mutations: {
    ...mapMutations(),
    setSelecteds: (state, payload) => {
      let tags = {}
      for (let categorie in payload) {
        if (payload[categorie].length === 0) continue
        tags[categorie] = payload[categorie]
      }
      state.selecteds = JSON.parse(JSON.stringify(tags))
    },
    SET_TEXT_TAGS_FILTERS: (state, payload) => {
      state.textTagsFilters = payload
    }
  },
  actions: {
    ...mapActions(collection, model, connection),
    setTagsDashboard: (context, { payload, tags }) => {
      context.commit('setSelecteds', payload)
      context.dispatch('setTextFilters', {
        payload,
        tags
      })
    },
    setTextFilters: (context, { payload, tags }) => {
      try {
        if (!payload || !tags) {
          return
        }

        const tagsFilter = {}

        for (let categorie in payload) {
          if (payload[categorie].length === 0) {
            continue
          }
          if (!tagsFilter.hasOwnProperty(categorie)) {
            tagsFilter[categorie] = []
          }
          for (let tagId of payload[categorie]) {
            const tag = tags.find(item => item._id === tagId)
            if (tag) {
              tagsFilter[categorie].push(tag.name)
            }
          }
        }

        let text = ''
        const keysTagsFilter = Object.keys(tagsFilter)
        const ammountCategories = keysTagsFilter.length
        for (let iterator = 0; iterator < ammountCategories; iterator++) {
          const categorie = keysTagsFilter[iterator]
          text += '(' + tagsFilter[categorie].join(' ou ') + ')'
          if (iterator < (ammountCategories - 1)) {
            text += ' e '
          }
        }

        context.commit('SET_TEXT_TAGS_FILTERS', text)
        return text
      } catch (e) {
        console.log(e)
      }
    }
  },
  getters: {
    ...getters,
    loading: state => state.loading,
    validations: state => state.validations,
    count: state => state.count,
    selecteds: state => state.selecteds,
    selectedsIds: state => {
      let ids = []
      for (let c in state.selecteds) {
        for (let id of state.selecteds[c]) {
          ids.push(id)
        }
      }
      return ids
    },
    textTagsFilters: state => state.textTagsFilters,
    tagsByCategories: state => state.all.reduce((accumulator, current) => {
      if (!accumulator.hasOwnProperty(current.categorieId)) accumulator[current.categorieId] = []
      accumulator[current.categorieId].push(current)
      return accumulator
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tags.js